



























































































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Moment } from 'moment';
import SvgIcon from '@/components/SvgIcon.vue';

const moment = require('moment');

@Component({
  name: 'PerformanceGroupedBarWeeksDiagram',
  components: {
    SvgIcon,
  },
})
export default class PerformanceGroupedBarWeeksDiagram extends Vue {
  @Prop({ default: 242 }) protected maxHeight!: any;

  @Prop({ default: '%' }) protected unit!: string;

  @Prop() protected values!: any;

  @Prop() protected types!: any;

  @Prop() protected yourLegendName!: string;

  @Prop() protected fixedYAxisStep!: any;

  @Prop() protected selectedValues!: any;

  @Prop() protected trends!: any;

  @Prop() protected lineMarker!: any;

  protected trendsPrepared: any = [];

  protected get valuesPrepared() {
    if (!this.values) {
      return [];
    }
    return this.values.map((item: any) => {
      const dateMoment: any = moment(item.date);
      return {
        ...item,
        label: `Week ${dateMoment.format('W')} · Starts on ${dateMoment.format('MMM D, YYYY')}`,
      };
    });
  }

  protected mounted(): void {
    if (this.$refs.trendsContainer) {
      this.trendsPrepared = this.trendsPrepare();
    }
    window.addEventListener('resize', () => {
      if (this.$refs.trendsContainer) {
        this.trendsPrepared = this.trendsPrepare();
      }
    });
  }

  @Watch('trends', { deep: true, immediate: true })
  protected onChangeTrends() {
    this.trendsPrepared = this.trendsPrepare();
  }

  protected trendPrepare(trend: any) {
    let trendsContainerWidth: number = 900;
    if (this.$refs.trendsContainer) {
      const trendsContainerClientRect: any = (this.$refs.trendsContainer as any).getBoundingClientRect();
      trendsContainerWidth = trendsContainerClientRect.width;
    }
    let result: any = {};
    if (trend.points) {
      const value1Index: any = 0;
      const value2Index: any = this.values.length - 1;
      const point1: any = trend.points[0];
      const point2: any = trend.points[1];
      const columnWidthPixels = this.columnWidth / 100 * trendsContainerWidth;
      result = {
        ...trend,
        point1: {
          x: value1Index * columnWidthPixels + columnWidthPixels / 2,
          y: this.getRectHeight(point1),
        },
        point2: {
          x: value2Index * columnWidthPixels + columnWidthPixels / 2,
          y: this.getRectHeight(point2),
        },
      };
    } else {
      const value1Index: any = this.values.findIndex((item: any) => item.label === trend.point1);
      const value2Index: any = this.values.findIndex((item: any) => item.label === trend.point2);
      const maxValue1: any = Math.max(...this.values[value1Index].bars.map((bar: any) => (bar ? bar.value : 0)));
      const maxValue2: any = Math.max(...this.values[value2Index].bars.map((bar: any) => (bar ? bar.value : 0)));
      const columnWidthPixels = this.columnWidth / 100 * trendsContainerWidth;
      result = {
        point1: {
          x: value1Index * columnWidthPixels + columnWidthPixels / 2,
          y: this.getRectHeight(maxValue1) - 15,
        },
        point2: {
          x: value2Index * columnWidthPixels + columnWidthPixels / 2,
          y: this.getRectHeight(maxValue2) - 15,
        },
      };
    }
    const lineWidth: any = result.point2.x - result.point1.x;
    const height: any = result.point2.y - result.point1.y;
    const tang: number = height / lineWidth;
    const corner: number = Math.atan(tang);
    result.line = {
      x: result.point1.x,
      y: result.point1.y,
      width: height / Math.sin(corner),
      rotate: -corner * 180 / Math.PI,
    };
    result.type = (result.point2.y - result.point1.y) > 0 ? 'up' : 'down';
    return result;
  }

  protected trendsPrepare() {
    if (!this.trends) {
      return [];
    }
    return this.trends.map((trend: any) => this.trendPrepare(trend));
  }

  protected get legends() {
    const result: any = [
      this.yourLegendName,
      ...this.types.map((item: any) => item.title),
    ];
    return result;
  }

  protected get yAxisStep(): number {
    if (this.fixedYAxisStep) {
      return this.fixedYAxisStep;
    }
    if (this.maxValue < 10) {
      return 1;
    }
    if (this.maxValue < 100) {
      return 10;
    }
    if (this.maxValue < 1000) {
      return 100;
    }
    return 1000;
  }

  protected get maxValueRounded() {
    return Math.ceil(this.maxValue / this.yAxisStep) * this.yAxisStep;
  }

  protected get yAxis() {
    const result = [];
    const stepsCount: number = this.maxValueRounded / this.yAxisStep;
    result.push({
      label: this.unit,
      y: 0,
    });
    for (let i = 1; i <= stepsCount; i += 1) {
      const value = this.yAxisStep * i;
      result.push({
        label: value,
        y: this.getRectHeight(value),
      });
    }
    return result;
  }

  protected get columnWidth(): number {
    return 100 / this.values.length;
  }

  protected get maxValue() {
    const percents: number[] = this.values
      .map(({ bars }: any) => Math.max(...bars.map((bar: any) => (bar ? bar.value : 0))));
    return Math.max(...percents);
  }

  protected getRectHeight(value: any) {
    return this.maxHeight / this.maxValueRounded * value;
  }

  protected getSelectedValue(label: string): any {
    if (!this.selectedValues) {
      return null;
    }
    return this.selectedValues.find((item: any) => item.label === label);
  }

  protected get labels() {
    if (!this.values || this.values.length < 2) {
      return [];
    }
    const result = [];
    let firstDate: Moment = moment(this.values[0].date);
    const lastDate: Moment = moment(this.values[this.values.length - 1].date);

    let dateFormat: string = 'MMM';
    const nextDate: Moment = firstDate.clone();
    while (nextDate <= lastDate) {
      nextDate.add(1, 'months').startOf('months');
      if (!result.length) {
        dateFormat = 'MMM YYYY';
      }
      const days = nextDate >= lastDate
        ? lastDate.diff(firstDate, 'days')
        : nextDate.diff(firstDate, 'days');
      result.push({
        weeks: Math.ceil(days / 7),
        label: firstDate.format(dateFormat),
      });
      dateFormat = 'MMM';
      if (firstDate.format('YYYY') !== nextDate.format('YYYY')) {
        dateFormat = 'MMM YYYY';
      }
      firstDate = nextDate.clone();
    }
    return result;
  }

  protected get labelsWeeksCount() {
    return this.labels
      .map(({ weeks }: any) => weeks)
      .reduce((a: number, b: number) => a + b);
  }

  protected getLabelWidth(weeksCount: number) {
    return Math.round(weeksCount / this.labelsWeeksCount * 1000) / 10;
  }
}
